export function formatFullName(nombre, apellidoPaterno, apellidoMaterno) {
  return [nombre, apellidoPaterno, apellidoMaterno]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" ");
}
